// @ts-nocheck

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import Chat from "../../components/Chat/Chat";
import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../utils/api";

export const Route = createFileRoute("/chats/$roomId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { description, info, status } = Route.useSearch();
  const navigate = useNavigate();

  const { roomId } = Route.useParams();
  const [isValidRoom, setIsValidRoom] = useState(false);
  const [userID, setUserID] = useState();
  const [tag, setTag] = useState();
  useEffect(() => {
    if (localStorage.getItem("auth")) {
      const authRaw = localStorage.getItem("auth");
      if (authRaw) {
        const auth = JSON.parse(authRaw);
        const id = auth["tag"].replace(/\s/g, "").split(",");
        setUserID(id);
      }
    }
  }, [sessionStorage]);
  useEffect(() => {
    fetch(
      `${API_BASE_URL}/rooms?details=1756465460831`
    )
      .then((response) => response.json())
      .then((response) => response.filter((item) => item.id == roomId))
      .then((item) => setTag(item[0]["tag"]))
      .catch((err) => console.error(err));
  }, [roomId]);

  useEffect(() => {
    if (tag) {
      if (userID.includes("ALL")) {
        setIsValidRoom(true);
      } else {
        if (!userID.includes(tag)) {
          navigate({ to: "/chats" });
        } else {
          setIsValidRoom(true);
        }
      }
    }
  }, [tag]);
  // useEffect(() => {
  //   if (tag.length) {
  //     if (tag[0]['tag'])
  // }, [tag])
  if (!isValidRoom) {
    return null;
  }
  return (
    <Chat
      roomId={roomId}
      description={description}
      info={info}
      status={status}
    />
  );
}
